import Aegis from 'aegis-web-sdk';
import { isFunction } from 'lodash';

let aegis = null;

function aegisInit() {
  aegis = new Aegis({
    id: '14aQ5nM9Gl4EAGlZPx', // 应用ID，即上报key
    reportApiSpeed: true, // 接口测速
    reportAssetSpeed: true, // 静态资源测速
    spa: true, // spa 应用页面跳转的时候开启 pv 计算
  });
}

function aegisInitTest() {
  aegis = new Aegis({
    id: '2keOW0ARrQwEA7dpvn', // 上报 id
    reportApiSpeed: true, // 接口测速
    reportAssetSpeed: true, // 静态资源测速
    spa: true, // spa 应用页面跳转的时候开启 pv 计算
    ext1: 'tpp-portal-web-test', // 扩展字段1
  });
}

function aegisError(message) {
  setTimeout(() => {
    if (aegis && isFunction(aegis.error)) {
      aegis.error(message);
    }
  }, 0);
}

export { aegisInit, aegisError, aegisInitTest };
